var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _circle, _circle2, _circle3, _circle4, _path28, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapvehicleicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 53,
    viewBox: "0 0 28 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9338 6.1745L23.9338 48.8999C23.9338 50.3072 22.7431 51.4494 21.2761 51.4494L11.2978 51.4494C9.83069 51.4494 8.63999 50.3072 8.63999 48.8999L8.63999 6.1745C8.63999 3.18444 11.1707 0.756835 14.2876 0.756836L18.2862 0.756836C21.4032 0.756836 23.9338 3.18444 23.9338 6.1745Z",
    fill: "url(#paint0_linear_23117_3246)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 7.45089L19 50.4354C19 51.8512 17.91 53.0004 16.5671 53.0004L7.43292 53.0004C6.08997 53.0004 5 51.8512 5 50.4354L5 6.50037C5 3.49217 7.31657 2.00037 10.1699 2.00037L13.8301 2.00037C16.6834 2.00037 19 4.44269 19 7.45089Z",
    fill: "#AAA5A5",
    fillOpacity: 0.53
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9338 4.99453L23.9338 48.8999C23.9338 50.3072 22.7431 51.4494 21.2761 51.4494L11.2978 51.4494C9.8307 51.4494 8.63999 50.3072 8.63999 48.8999L8.63999 4.99453C8.63999 2.00446 11.1707 0.756835 14.2876 0.756836L18.2862 0.756836C21.4032 0.756836 23.9338 2.00447 23.9338 4.99453Z",
    fill: "url(#paint1_linear_23117_3246)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1958 49.4505C23.1958 50.4661 22.3347 51.292 21.2761 51.292L11.2978 51.292C10.2391 51.292 9.37803 50.4661 9.37803 49.4505L9.37803 5.02199C9.37803 2.6699 11.3724 1.38609 13.8243 1.38609L18.7503 1.38609C21.2023 1.38609 23.1966 2.6699 23.1966 5.02199L23.1966 49.4505M23.9338 49.4505L23.9338 5.02199C23.9338 2.275 21.6131 0.6781 18.7495 0.6781L13.8235 0.6781C10.9607 0.6781 8.63917 2.275 8.63917 5.02199L8.63917 49.4505C8.63917 50.8586 9.82905 52 11.2969 52L21.2761 52C22.7439 52 23.9338 50.8586 23.9338 49.4505Z",
    fill: "url(#paint2_radial_23117_3246)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2538 11.9705L22.2538 8.22529C22.2538 7.07732 22.3636 5.93198 22.5818 4.80493L22.5818 11.9705L22.2538 11.9705Z",
    fill: "#8C8C8C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2535 49.3718L22.2535 18.764L22.5815 18.764L22.5815 49.3718L22.2535 49.3718Z",
    fill: "#8C8C8C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9669 49.0572L9.9669 4.80493C10.1847 5.64272 10.2949 6.50482 10.2949 7.37045L10.2949 49.0572L9.9669 49.0572Z",
    fill: "#8C8C8C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5513 21.6802L20.5513 8.49511C20.5513 8.19491 20.2976 7.95154 19.9846 7.95154L12.5862 7.95154C12.2732 7.95154 12.0195 8.19491 12.0195 8.49511L12.0195 21.6802C12.0195 21.9804 12.2732 22.2238 12.5862 22.2238L19.9846 22.2238C20.2976 22.2238 20.5513 21.9804 20.5513 21.6802Z",
    fill: "url(#paint3_linear_23117_3246)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8967 21.0619L19.8967 10.6852C19.8967 10.385 19.643 10.1416 19.3301 10.1416L13.2412 10.1416C12.9283 10.1416 12.6746 10.385 12.6746 10.6852L12.6746 21.0619C12.6746 21.3621 12.9283 21.6055 13.2412 21.6055L19.3301 21.6055C19.643 21.6055 19.8967 21.3621 19.8967 21.0619Z",
    fill: "url(#paint4_linear_23117_3246)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M20.0305 9.01267L20.0305 8.40931C20.0305 8.34371 19.9751 8.29053 19.9067 8.29053L12.6649 8.29053C12.5965 8.29053 12.541 8.34371 12.541 8.40931L12.541 9.01267C12.541 9.07828 12.5965 9.13146 12.6649 9.13146L19.9067 9.13146C19.9751 9.13146 20.0305 9.07828 20.0305 9.01267Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3272 9.13067L16.3272 8.29053L16.4092 8.29053L16.4092 9.13067L16.3272 9.13067Z",
    fill: "#2D2D2D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 33.9314L18.5762 26.8509C18.5762 26.6897 18.4399 26.559 18.2719 26.559L14.2988 26.559C14.1308 26.559 13.9945 26.6897 13.9945 26.8509L13.9945 33.9314C13.9945 34.0926 14.1308 34.2233 14.2988 34.2233L18.2719 34.2233C18.4399 34.2233 18.5762 34.0926 18.5762 33.9314Z",
    fill: "url(#paint5_linear_23117_3246)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2246 33.5993L18.2246 28.0269C18.2246 27.8657 18.0884 27.735 17.9203 27.735L14.6505 27.735C14.4825 27.735 14.3462 27.8657 14.3462 28.0269L14.3462 33.5993C14.3462 33.7605 14.4825 33.8912 14.6505 33.8912L17.9203 33.8912C18.0884 33.8912 18.2246 33.7605 18.2246 33.5993Z",
    fill: "url(#paint6_linear_23117_3246)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M18.2966 27.1288L18.2966 26.8048C18.2966 26.7695 18.2669 26.741 18.2301 26.741L14.3412 26.741C14.3045 26.741 14.2747 26.7695 14.2747 26.8048L14.2747 27.1288C14.2747 27.164 14.3045 27.1926 14.3412 27.1926L18.2301 27.1926C18.2669 27.1926 18.2966 27.164 18.2966 27.1288Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3078 27.1921L16.3078 26.741L16.3518 26.741L16.3518 27.1921L16.3078 27.1921Z",
    fill: "#2D2D2D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5762 45.9672L18.5762 38.8866C18.5762 38.7254 18.4399 38.5947 18.2719 38.5947L14.2988 38.5947C14.1308 38.5947 13.9945 38.7254 13.9945 38.8866L13.9945 45.9672C13.9945 46.1284 14.1308 46.2591 14.2988 46.2591L18.2719 46.2591C18.4399 46.2591 18.5762 46.1284 18.5762 45.9672Z",
    fill: "url(#paint7_linear_23117_3246)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2246 45.6351L18.2246 40.0627C18.2246 39.9014 18.0884 39.7708 17.9203 39.7708L14.6505 39.7708C14.4825 39.7708 14.3462 39.9014 14.3462 40.0627L14.3462 45.6351C14.3462 45.7963 14.4825 45.927 14.6505 45.927L17.9203 45.927C18.0884 45.927 18.2246 45.7963 18.2246 45.6351Z",
    fill: "url(#paint8_linear_23117_3246)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M18.2966 39.1645L18.2966 38.8405C18.2966 38.8053 18.2669 38.7767 18.2301 38.7767L14.3412 38.7767C14.3045 38.7767 14.2747 38.8053 14.2747 38.8405L14.2747 39.1645C14.2747 39.1998 14.3045 39.2283 14.3412 39.2283L18.2301 39.2283C18.2669 39.2283 18.2966 39.1998 18.2966 39.1645Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3078 39.2279L16.3078 38.7767L16.3518 38.7767L16.3518 39.2279L16.3078 39.2279Z",
    fill: "#2D2D2D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7024 5.9643L10.5721 5.03369L21.8542 5.03369L21.7304 5.9643L10.7024 5.9643Z",
    fill: "#5B5B5B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8544 5.03371L10.5722 5.03371L10.5722 3.77507C10.5722 3.77507 10.9822 2.93571 13.4973 2.51643C16.0124 2.09714 18.9744 2.51643 18.9744 2.51643C18.9744 2.51643 20.5948 2.71309 21.9036 3.94735L21.8535 5.03371L21.8544 5.03371Z",
    fill: "#7C7C7C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7295 1.10547L21.826 2.02377C22.0619 2.10868 22.3725 2.0757 22.5809 1.97605C22.0732 1.62377 21.6776 1.22716 20.7358 0.953403C19.8258 0.688865 19.5055 0.705867 19.2188 0.717407C19.31 0.929527 19.4908 1.02126 19.7295 1.10547Z",
    fill: "url(#paint9_radial_23117_3246)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2633 2.12007L12.1383 1.35239C12.3381 1.25478 12.4234 1.00487 12.4939 0.812496C11.961 0.919467 11.5542 0.952714 10.7961 1.38189C10.0636 1.79661 9.9203 2.00817 9.74707 2.19652C9.93314 2.26775 10.0622 2.21985 10.2633 2.12007Z",
    fill: "url(#paint10_radial_23117_3246)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.72527 4.61133L9.66504 4.61133L9.66504 4.84732L8.72527 4.84732C8.46518 4.84732 8.25456 5.04937 8.25456 5.29886L8.25456 5.8621L8.00855 5.8621L8.00855 5.29886C8.00855 4.91903 8.32931 4.61133 8.72527 4.61133Z",
    fill: "#969696"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00903 5.86216C9.00903 5.94906 8.9356 6.01949 8.84502 6.01949L7.49195 6.01949C7.40137 6.01949 7.32794 5.94906 7.32794 5.86216C7.32794 5.77527 7.40137 5.70483 7.49195 5.70483L8.84502 5.70483C8.9356 5.70483 9.00903 5.77527 9.00903 5.86216Z",
    fill: "#969696"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6026 4.61133L22.6628 4.61133L22.6628 4.84732L23.6026 4.84732C23.8627 4.84732 24.0733 5.04937 24.0733 5.29886L24.0733 5.8621L24.3193 5.8621L24.3193 5.29886C24.3193 4.91903 23.9986 4.61133 23.6026 4.61133Z",
    fill: "#969696"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3188 5.86216C23.3188 5.94906 23.3923 6.01949 23.4829 6.01949L24.8359 6.01949C24.9265 6.01949 24.9999 5.94906 24.9999 5.86216C24.9999 5.77527 24.9265 5.70483 24.8359 5.70483L23.4829 5.70483C23.3923 5.70483 23.3188 5.77527 23.3188 5.86216Z",
    fill: "#969696"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.2857,
    cy: 51.4144,
    r: 0.214289,
    transform: "rotate(90 10.2857 51.4144)",
    fill: "#D14545"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.857,
    cy: 51.1143,
    r: 0.214289,
    transform: "rotate(90 9.857 51.1143)",
    fill: "#D14545"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.214289,
    cy: 0.214289,
    r: 0.214289,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 22.1001 51.2001)",
    fill: "#D14545"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.214289,
    cy: 0.214289,
    r: 0.214289,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 22.5288 50.9)",
    fill: "#D14545"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3999 52C11.3999 51.7791 11.579 51.6 11.7999 51.6H20.9999C21.2208 51.6 21.3999 51.7791 21.3999 52H11.3999Z",
    fill: "#C71F1F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23117_3246",
    x1: 16.2869,
    y1: 0.756836,
    x2: 16.2869,
    y2: 62.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89B4F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FB2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_23117_3246",
    x1: 16.2869,
    y1: 0.756836,
    x2: 16.2869,
    y2: 62.4578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E6E6E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_23117_3246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.2865 0.6781) rotate(90) scale(51.3219 15.2947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#767676"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_23117_3246",
    x1: 16.2854,
    y1: 7.95154,
    x2: 16.2854,
    y2: 22.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_23117_3246",
    x1: 16.2857,
    y1: 10.1416,
    x2: 16.2857,
    y2: 21.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_23117_3246",
    x1: 16.2853,
    y1: 26.559,
    x2: 16.2853,
    y2: 34.2233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_23117_3246",
    x1: 16.2854,
    y1: 27.735,
    x2: 16.2854,
    y2: 33.8912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_23117_3246",
    x1: 16.2853,
    y1: 38.5947,
    x2: 16.2853,
    y2: 46.2591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#848484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_23117_3246",
    x1: 16.2854,
    y1: 39.7708,
    x2: 16.2854,
    y2: 45.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_23117_3246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.917 1.32389) rotate(-151.845) scale(1.30853 1.27876)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515252"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_23117_3246",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.1431 1.48055) rotate(162.143) scale(1.15552 1.10886)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#525454"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapvehicleicon);
export default __webpack_public_path__ + "static/media/mapvehicleicon.49bd8dc6a4347aafe1f9734539d1c069.svg";
export { ForwardRef as ReactComponent };